export default {
    methods: {
        print() {
            return {
                agendamento(agendamento) {

                    const page = window.open('', Math.random())

                    const date = new Date().toLocaleString();

                    const image = page.document.createElement('img')

                    image.style.height = '30px';

                    image.src = agendamento.logotipo ? require(`@/assets/cliente/logotipo/${agendamento.logotipo}`) : null

                    let urgente = agendamento.urgente ?
                        `<p><strong>PEDIDO COM URGÊNCIA</strong></p><p class="line"></p>` : ''

                    let prefeitura = agendamento.nomePrefeitura ? `
                        <strong>PREFEITURA DE ${agendamento.nomePrefeitura}</strong>
                        ` : ''

                    let ramoAtividade = agendamento.ramoAtividade ? `Secretaria Municipal de ${agendamento.ramoAtividade}` : ''

                    let sistemaNome = agendamento.sistemaNome ? `${agendamento.sistemaNome}` : ''
                    let sistemaVersao = agendamento.sistemaVersao ? `${agendamento.sistemaVersao}` : ''
                    let responsavel = agendamento.nomeResponsavel ?
                        ` <strong>Responsável:</strong><br />${agendamento.nomeResponsavel}` : ''

                    let observacao = agendamento.observacao ? ` <p class="line"></p> ${agendamento.observacao}` : ''
                    let nomeSocial = agendamento.pacienteNomeSocial ? ` (${agendamento.pacienteNomeSocial})` : ''

                    let regulacaoMensagemComprovanteAgendamento = '';

                    let protocoloFechamento = agendamento.regulacaoSolicitacaoNumero
                        ? `<tr><td class="report-content-cell">
                            <div id="codagendamento"><strong>PROTOCOLO DE FECHAMENTO:</strong>
                                <span id="agendamentoSpan">${agendamento.regulacaoSolicitacaoNumero}</span>
                            </div></td></tr>

                            <tr>
                                <td class="report-content-cell">
                                </td>
                            </tr>`
                        : ''

                    if (agendamento.regulacaoMensagemComprovanteAgendamento) {
                        regulacaoMensagemComprovanteAgendamento = `
                            <tr>
                                <td class="report-content-cell">
                                    <div id="compReg">
                                        <fieldset>
                                            <table>
                                                <tr>
                                                    <td>${agendamento.regulacaoMensagemComprovanteAgendamento}</td>
                                                </tr>
                                            </table>
                                        </fieldset>
                                    </div>
                                </td>
                            </tr>
                        `;
                    }

                    let table = '<table>'

                    table = table + `
                        <thead>
                            <tr>
                                <th colspan="2" style="border-bottom: 1px solid #000000; padding: 7px;">
                                    EXAMES SOLICITADOS
                                </th>
                            </tr>
                        </thead>
                    `
                    table = table + `
                        <thead style="text-align: -webkit-left;">
                            <tr>
                                <th>Código</th>
                                <th>Descrição</th>
                            </tr>
                        </thead>
                    `

                    table = table + `
                        <tr>
                            <td colspan="2" style="border-bottom:1px solid #000000"></td>
                        </tr>
                    `

                    agendamento.examesIncluido.forEach(exame => {

                        table = table + `
                            <tr>
                                <td class="pr-10" class="pr-10">${exame.codigo}</td>
                                <td>${exame.nome}</td>
                            </tr>
                        `
                        if(exame.observacao){
                            table = table + `
                                <tr>
                                    <td colspan="2"><strong>Obs:</strong> ${exame.observacao}</td>
                                </tr>
                            `
                        }

                        table = table + `
                            <tr>
                                <td colspan="2" style="border-bottom:1px dotted #dbdbdb"></td>
                            </tr>
                        `
                    })

                    table.concat(`</table>`)

                    page.document.write(`
                         <head>
                            <title>Pedido do Agendamento</title>

                            <style>
                                * {
                                    font-family: 'Arial', Gadget, sans-serif;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 8cm;
                                    max-width: 8cm;
                                    border-collapse: collapse;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 8cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    border:  1px solid #000000;
                                }
                                #paciente {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #pedido {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #localColeta {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #obs, #compReg {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    margin-bottom:  10px;
                                }
                                #left-col {
                                    flex-grow: 1;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.05cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.35cm;
                                    margin: 0.05cm 0;
                                    padding: 0;
                                }
                                .line {
                                   border-bottom: 1px dotted #c7c7c7;
                                   margin: 5px 0
                                }
                                .lineBottom {
                                   border-bottom: 2px solid #000000;
                                }
                                .pr-10 {
                                   padding-right: 10px;
                                }
                                .pr-10 {
                                   padding-right: 10px;
                                }
                                fieldset{
                                    width: 100%;
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    padding: 0 5px;
                                }
                                legend {
                                    font-family: Arial, Helvetica, sans-serif;
                                    font-size: 15px;
                                    font-weight: 100!important;
                                }
                                #codagendamento {
                                    border: 1px solid #000000;
                                    padding: 5px;
                                    margin-top: 5px;
                                    font-size: 12px;
                                    font-weight: 500;
                                    text-align: -webkit-center;
                                }
                                #coleta {
                                    border: 1px solid #000000;
                                    width: 31%;
                                    float: left;
                                    margin-top: 10px;
                                    padding: 5px 0 3px 0;
                                    text-align: -webkit-center;
                                    font-size: 12px;
                                    min-height: 35px;
                                }
                                #horario {
                                    border: 1px solid #000000;
                                    width: 31%;
                                    float: left;
                                    margin-top: 10px;
                                    margin-left: 2.5%;
                                    padding: 5px 0 3px 0;
                                    text-align: -webkit-center;
                                    font-size: 12px;
                                    min-height: 35px;
                                }
                                #entrega {
                                    border: 1px solid #000000;
                                    width: 31%;
                                    float: left;
                                    margin-top: 10px;
                                    margin-left: 2.5%;
                                    padding: 5px 0 3px 0;
                                    text-align: -webkit-center;
                                    font-size: 12px;
                                    min-height: 35px;
                                }
                                #rodape-left {
                                    width: 25%;
                                    float: left;
                                    margin-top: 5px;
                                    font-size: 9px;
                                    text-align:  left;
                                }
                                #rodape-right {
                                    width: 75%;
                                    float: right;
                                    margin-top: 5px;
                                    font-size: 9px;
                                    text-align: right;
                                }
                                table {
                                    width: 100%;
                                }
                                tr {
                                    border: 1px solid black;
                                    border-collapse: collapse;
                                }
                                td {
                                    font-size: 13px;
                                }
                                #img {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                #prefeitura {
                                   text-align: center;
                                   padding-top: 5px;
                                   text-transform: uppercase;
                                }
                                #ramoAtividade {
                                    text-align: center;
                                    padding-bottom: 10px;
                                }
                                #prontuario {
                                    float: left;
                                    width: 50%;
                                }
                                #cpf {
                                    float: left;
                                    width: 50%;
                                }
                                #dataNascimento {
                                    float: left;
                                    width: 100%;
                                }
                                #responsavel {
                                    clear:  both;
                                    width: 100%;
                                }
                                .titulo {
                                    font-size: 16px;
                                    text-align: center;
                                    padding: 10px 0 3px 0;
                                }
                                .b-0 {
                                    border: 0;
                                }
                                .b-0 {
                                    border: 0;
                                }
                                #agendamentoSpan {
                                    font-size: 18px;
                                    text-align: center;
                                    font-weight: 700;
                                }
                                #unidadeColeta {
                                    font-size: 16px;
                                    text-align: left;
                                    font-weight: 700;
                                }
                            </style>
                        </head>

                        <body>

                            <table class="report-container">
                                <thead class="report-header">
                                    <tr class="b-0">
                                        <th class="report-header-cell">
                                            <div class="header-info">

                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot class="report-footer">
                                    <tr class="b-0">
                                        <td class="report-footer-cell">
                                            <div class="footer-info">

                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>

                                <tbody class="report-content">
                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="img"></div>
                                            <div id="prefeitura"></div>
                                            <p id="ramoAtividade"></p>
                                            <div class="lineBottom"></div>
                                            <div class="titulo"><strong>DADOS DO AGENDAMENTO</strong></div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                        <tr>
                                        <td class="report-content-cell">
                                            <div id="paciente">
                                                    <fieldset>
                                                        <legend>Dados do paciente</legend>
                                                        <div id="left-col">
                                                            <p>
                                                                <strong>Paciente:</strong><br />
                                                                ${agendamento.pacienteNome} <strong>${nomeSocial}</strong>
                                                            </p>
                                                            <p id="prontuario">
                                                                <strong>Prontuário:</strong><br />
                                                                ${agendamento.prontuario}
                                                            </p>
                                                            <p id="cpf">
                                                                <strong>CPF:</strong><br />
                                                                ${agendamento.cpf}
                                                            </p>
                                                            <p id="dataNascimento">
                                                                <strong>Data nascimento:</strong><br />
                                                                ${agendamento.dataNascimento}
                                                            </p>
                                                            <p id="responsavel"></p>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                        </td>
                                    </tr>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="pedido">
                                                <fieldset style="margin:5px 0">
                                                    <legend>Dados do pedido</legend>
                                                    <div id="left-col">
                                                        <div id="urgente"></div>
                                                        <p><strong>Médico solicitante:</strong> ${agendamento.medicoNome}</p>
                                                        <p class="line"></p>
                                                        <p><strong>Unidade solicitante:</strong> ${agendamento.unidade}</p>
                                                        <p><strong>Endereço:</strong>
                                                            ${agendamento.tipo}
                                                            ${agendamento.endereco},
                                                            ${agendamento.numeroEndereco}<br>
                                                            ${agendamento.bairro} -
                                                            ${agendamento.cep} /
                                                            ${agendamento.telefone}
                                                        </p>
                                                        <p class="line"></p>
                                                        <p><strong>Laboratório:</strong> ${agendamento.laboratorio}</p>
                                                        <p><strong>Endereço:</strong>
                                                            ${agendamento.tipoLaboratorio}
                                                            ${agendamento.enderecoLaboratorio},
                                                            ${agendamento.numeroEnderecoLaboratorio}<br>
                                                            ${agendamento.bairroLaboratorio} -
                                                            ${agendamento.cepLaboratorio} /
                                                            ${agendamento.telefoneLaboratorio}
                                                        </p>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                        <tr>
                                        <td class="report-content-cell">
                                            <div id="codagendamento">
                                                <strong>CÓDIGO DO AGENDAMENTO:</strong>
                                                <span id="agendamentoSpan">${agendamento.agendamentoNumero}</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell" id="protocoloFechamento"></td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">

                                                <div>
                                                    <div id="coleta">
                                                        <strong>COLETA:</strong><br />
                                                        <span id="agendamentoSpan">${agendamento.data}</span>
                                                    </div>
                                                    <div id="horario">
                                                        <strong>HORÁRIO:</strong><br />
                                                        <span id="agendamentoSpan">${agendamento.horaExame}</span>
                                                    </div>
                                                    <div id="entrega">
                                                        <strong>ENTREGA:</strong><br />
                                                        <span id="agendamentoSpan">${agendamento.dataEntrega}</span>
                                                    </div>
                                                </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">

                                                <div id="localColeta">
                                                    <fieldset style="margin:5px 0">
                                                        <legend>Local de coleta</legend>
                                                        <div id="left-col">

                                                        <p id="unidadeColeta">${agendamento.localColeta}</p>
                                                        <p><strong>Endereço:</strong>
                                                            ${agendamento.tipoColeta}
                                                            ${agendamento.enderecoColeta},
                                                            ${agendamento.numeroEnderecoColeta}<br>
                                                            ${agendamento.bairroColeta} -
                                                            ${agendamento.cepColeta} /
                                                            ${agendamento.telefoneColeta}
                                                        </p>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell" id="table">

                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="obs">
                                                <fieldset>
                                                    <legend>Observação</legend>
                                                    <table>
                                                        <tr>
                                                            <td>${agendamento.mensagemProtocolo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td id="observacao"></td></td>
                                                        </tr>
                                                    </table>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    ${regulacaoMensagemComprovanteAgendamento}

                                    <tr>
                                        <td class="report-content-cell">
                                        <tr>
                                        <td class="report-content-cell">
                                            <div class="lineBottom"></div>

                                            <div>
                                                <div id="rodape-left">
                                                    <span id="sistemaNome"></span>
                                                    <span id="sistemaVersao"></span>
                                                </div>
                                                <div id="rodape-right">
                                                    <span>Impresso por: ${agendamento.usuarioNomeSocial ? agendamento.usuarioNomeSocial : agendamento.usuario}</span><br/>
                                                    <span>Data/hora da impressão: ${date}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </body>
                    `)

                    page.document.getElementById('img').appendChild(image)
                    page.document.getElementById('table').innerHTML = table
                    page.document.getElementById('urgente').innerHTML = urgente
                    page.document.getElementById('prefeitura').innerHTML = prefeitura
                    page.document.getElementById('ramoAtividade').innerHTML = ramoAtividade
                    page.document.getElementById('sistemaNome').innerHTML = sistemaNome
                    page.document.getElementById('sistemaVersao').innerHTML = sistemaVersao
                    page.document.getElementById('responsavel').innerHTML = responsavel
                    page.document.getElementById('observacao').innerHTML = observacao
                    page.document.getElementById('protocoloFechamento').innerHTML = protocoloFechamento

                    image.onload = function(){

                        page.print()
                        page.close()
                    }
                },
                etiqueta(etiqueta) {

                    const page = window.open('', Math.random())

                    let nomeSocial = etiqueta.pacienteNomeSocial ? ` (${etiqueta.pacienteNomeSocial})` : ''

                    page.document.write(`
                        <head>
                            <title>Etiqueta</title>

                            <style>
                                * {
                                    font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 10cm;
                                    height: 3cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #left-col {
                                    flex-grow: 1;
                                    padding-top:5px;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.10cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.25cm;
                                    margin: 0.08cm 0;
                                    padding: 0;
                                }
                            </style>
                        </head>

                        <body>
                            <div class="content">
                                <div class="paper">
                                    <h1>${etiqueta.pacienteNome} <span>${nomeSocial}</span></h1>

                                    <div class="container">
                                        <div id="header">
                                            <div id="left-col">
                                                <p>
                                                    <strong>IDADE:</strong> ${etiqueta.idade} -
                                                    <strong>PRONTUÁRIO:</strong> ${etiqueta.prontuario} -
                                                    <strong>NR. AGENDAMENTO:</strong> ${etiqueta.agendamentoNumero}
                                                </p>
                                                <p><strong>UNIDADE:</strong> ${etiqueta.unidadeNome}</p>
                                                <p><strong>LABORATÓRIO:</strong> ${etiqueta.laboratorioNome}</p>
                                                <p>${etiqueta.sistemaNome} ${etiqueta.sistemaVersao} - ${etiqueta.nomePrefeitura}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </body>
                    `)

                    page.print()
                    page.close()
                },
                etiquetaColeta(etiqueta) {

                    let etiquetas = ''

                    etiqueta.forEach(agendamento => {

                        let nomeSocial = agendamento.pacienteNomeSocial ?
                        ` (${agendamento.pacienteNomeSocial})` : ''

                        etiquetas = etiquetas + `

                        <tr>
                            <td class="report-content-cell">
                                <h1>${agendamento.pacienteNome} <span>${nomeSocial}</span></h1>

                                <div class="container">
                                    <div id="header">
                                        <div id="left-col">
                                            <p class="uppercase"><strong>IDADE:</strong> ${agendamento.pacienteIdade}</p>
                                            <p class="uppercase"><strong>EXAME:</strong> ${agendamento.siglaExame}</p>
                                            <p class="numero">*${agendamento.agendamentoNumero}*</p>
                                            <p><strong>UNIDADE:</strong> ${agendamento.infraestruturaNome}</p>
                                            <p><strong>LABORATÓRIO:</strong> ${agendamento.laboratorioInfraestruturaNome}</p>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        `
                    })

                    const page = window.open('', Math.random())

                    page.document.write(`
                        <head>
                            <title>Etiqueta</title>

                            <style>
                                * {
                                    font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 10.3cm;
                                    border-collapse: collapse;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 8cm;
                                    height: 2.80cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #left-col {
                                    flex-grow: 1;
                                    padding-top:5px;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.45cm;
                                    margin: 0;
                                    padding: 0.10cm 0.05cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.25cm;
                                    margin: 0.08cm 0;
                                    padding: 0;
                                }
                                .uppercase {
                                    text-transform: uppercase;
                                    font-size: 0.30cm;
                                }
                                .numero {
                                    font-size: 1cm;
                                    text-align: right
                                }
                                .pt3 {
                                    padding-top: 3px;
                                    font-size: 0.22cm;
                                }
                            </style>
                        </head>

                        <body>

                        <table class="report-container">
                                <thead class="report-header">
                                    <tr class="b-0">
                                        <th class="report-header-cell">
                                            <div class="header-info">

                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot class="report-footer">
                                    <tr class="b-0">
                                        <td class="report-footer-cell">
                                            <div class="footer-info">

                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>

                                <tbody class="report-content" id="etiquetas">

                                </tbody>
                        </body>
                    `)

                    page.document.getElementById('etiquetas').innerHTML = etiquetas

                    page.print()
                    page.close()
                },
                etiquetaColetaIndividual(agendamento, item) {

                    let nomeSocial = agendamento.pacienteNomeSocial ?
                        ` (${agendamento.pacienteNomeSocial})` : ''

                    let siglaExame = item ? item.siglaExame : agendamento.siglaExame

                    const page = window.open('', Math.random())

                    page.document.write(`
                        <head>
                            <title>Etiqueta</title>

                            <style>
                                * {
                                    font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 10.3cm;
                                    border-collapse: collapse;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 8cm;
                                    height: 2.80cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #left-col {
                                    flex-grow: 1;
                                    padding-top:5px;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.45cm;
                                    margin: 0;
                                    padding: 0.10cm 0.05cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.25cm;
                                    margin: 0.08cm 0;
                                    padding: 0;
                                }
                                .uppercase {
                                    text-transform: uppercase;
                                    font-size: 0.30cm;
                                }
                                .numero {
                                    font-size: 1cm;
                                    text-align: right
                                }
                                .pt3 {
                                    padding-top: 3px;
                                    font-size: 0.22cm;
                                }
                            </style>
                        </head>

                        <body>

                        <table class="report-container">
                                <thead class="report-header">
                                    <tr class="b-0">
                                        <th class="report-header-cell">
                                            <div class="header-info">

                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot class="report-footer">
                                    <tr class="b-0">
                                        <td class="report-footer-cell">
                                            <div class="footer-info">

                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>

                                <tbody class="report-content" id="etiquetas">

                                    <tr>
                                        <td class="report-content-cell">
                                            <h1>${agendamento.pacienteNome} <span>${nomeSocial}</span></h1>

                                            <div class="container">
                                                <div id="header">
                                                    <div id="left-col">
                                                        <p class="uppercase"><strong>IDADE:</strong> ${agendamento.pacienteIdade}</p>
                                                        <p class="uppercase"><strong>EXAME:</strong> ${siglaExame}</p>
                                                        <p class="numero">*${agendamento.agendamentoNumero}*</p>
                                                        <p><strong>UNIDADE:</strong> ${agendamento.infraestruturaNome}</p>
                                                        <p><strong>LABORATÓRIO:</strong> ${agendamento.laboratorioInfraestruturaNome}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                        </body>
                    `)

                    page.print()
                    page.close()
                },
            }
        }
    },
}